import { ProductTileImageProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/ProductTileImageProps";
import * as React from "react";
import { PropsWithChildren } from "react";

import { DynamicProductImage } from "./DynamicProductImage";

export const MaybeDynamicImage: React.FC<
  PropsWithChildren<ProductTileImageProps>
> = ({ children, ...tileImageProps }) => {
  const swatchesAndOptions =
    tileImageProps.optionDetails?.swatch_details?.swatches_and_options;
  if (!swatchesAndOptions || swatchesAndOptions.length === 0) {
    return <>{children}</>;
  }

  return <DynamicProductImage data={tileImageProps} />;
};
